import { COLLECTIONS, type Collection, type LocalStore } from "./types";

/** In-memory store: used in tests and as a last-resort fallback when no storage is available. */
export function createMemoryStore(): LocalStore {
  const data = new Map<Collection, Map<string, unknown>>(COLLECTIONS.map((c) => [c, new Map()]));
  const meta = new Map<string, unknown>();
  const clone = <T>(v: T): T => (v === undefined ? v : structuredClone(v));
  return {
    all: async <T>(c: Collection) => [...data.get(c)!.values()].map(clone) as T[],
    putMany: async (c, records) => {
      for (const r of records) data.get(c)!.set(r.id, clone(r));
    },
    getMeta: async <T>(key: string) => clone(meta.get(key)) as T | undefined,
    setMeta: async (key, value) => void meta.set(key, clone(value)),
    clear: async () => {
      for (const m of data.values()) m.clear();
      meta.clear();
    },
  };
}
